import { LoadingIcon } from '@newcore/icons';
import { cn } from '@newcore/ui/cn';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Sizes } from '@newcore/ui/enums/sizes';
import { Text } from '@newcore/ui/typography';
import { Command } from 'cmdk';
import { AppIcon } from '@/components/common/app-icon';
import type { UserApplication } from '@/types/api.types';
import { getApplicationIconUrl } from '@/utils/icon-utils';

interface ApplicationSearchItemProps {
  app: UserApplication;
  isLoading: boolean;
  onSelect: (application: UserApplication) => void;
}

export function ApplicationSearchItem({
  app,
  isLoading,
  onSelect,
}: ApplicationSearchItemProps) {
  const handleSelect = () => {
    onSelect(app);
  };

  return (
    <Command.Item
      key={app.app_id}
      value={app.app_id}
      onSelect={handleSelect}
      className={cn(
        'flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors',
        'text-primary',
        'data-[selected=true]:bg-secondary',
        'aria-disabled:opacity-50'
      )}
      disabled={isLoading}
    >
      <div className='flex items-center justify-center h-8 w-8 border p-1 rounded shrink-0'>
        <AppIcon
          iconUrl={getApplicationIconUrl(app.icon_path, app.app_name)}
          appName={app.app_name}
          size={Sizes.SM}
        />
      </div>
      <Text weight={FontWeights.MEDIUM} className='flex-1'>
        {app.app_name}
      </Text>
      {isLoading && (
        <LoadingIcon className='size-4 animate-spin text-tertiary' />
      )}
    </Command.Item>
  );
}
